import { FC } from "react";

import { IconView } from "@/components/_molecules/icon-picker/icon-view";

interface PriorityIconProps {
  priority?:
    | {
        color: string;
        icon?: string | null;
        iconType?: string | null;
      }
    | null
    | undefined;
  className?: string;
}

export const PriorityIcon: FC<PriorityIconProps> = ({ priority, className }) => {
  return <IconView icon={priority?.icon} iconType={priority?.iconType} color={priority?.color} className={className} />;
};
